import { useAalKpisQuery } from "../aalV2";

export type WalletAALKPIsFilters = {
  start_date: string;
  end_date: string;
};

export type WalletAALKPIsResponse = {
  rebet_cash_delta: string;
  casino_cash_delta: string;
  p_cash_delta: string;
  total_wallet_delta: string;
  rebet_cash_pct_change: number;
  casino_cash_pct_change: number;
  p_cash_pct_change: number;
  total_wallet_pct_change: number;
  comparison_start_date: string;
  comparison_end_date: string;
} | null;

export const useGetAALWalletKPIs = (filters: WalletAALKPIsFilters) => {
  const { start_date, end_date } = filters;

  return useAalKpisQuery<WalletAALKPIsResponse>("wallet", {
    start_date,
    end_date,
  });
};
